import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'common-ui-components';

export const PatternInput = React.forwardRef(({ onChange, value, pattern, ...props }, ref) => {
  const handleChange = (e) => {
    const inputValue = e.target.value;
    if (pattern.test(inputValue)) {
      onChange?.(e);
    }
  };

  return (
    <Input
      {...props}
      ref={ref}
      typeInput='text'
      value={value}
      onChange={handleChange}
    />
  );
});

PatternInput.displayName = 'PatternInput';

PatternInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  pattern: PropTypes.shape(RegExp).isRequired,
};
